export default __webpack_public_path__ + "static/home-bg-mobile-1e8272b223f741814a17b06b140288e7.jpg";